<template>
  <div>
    <!-- <pre>{{ dataAward }}</pre> -->
    <a-row class="mt-20">
      <!-- add new form -->
      <a-col :span="14" :offset="3">
        <a-form-item label="Achievements (s)" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" extra="">
          <a-button type="dashed" block @click="addNewAW">
            + Add Achievements
          </a-button>
        </a-form-item>
      </a-col>
    </a-row>

    <a-row>
      <a-col :span="20" :offset="2">
        <!-- list form -->
        <a-form :layout="'horizontal'">
          <a-list class="demo-loadmore-list" :loading="loading" item-layout="horizontal"
            :data-source="dataAward.slice().reverse()">
            <a-list-item slot="renderItem" slot-scope="item, index">
              <a-list-item-meta>
                <!-- <p slot="title" class="mt-0 mb-0">test</p> -->
                <div slot="description">
                  <a-row>
                    <a-col class="text-center" :span="20">
                      <a-row class="mt-10">
                        <a-col :span="8">
                          <h6 class="mt-5 mb-0">Name of Awards/Scholarship</h6>
                        </a-col>
                        <a-col :span="12">
                          <a-input v-model="item.name_of_award_scholarship" placeholder="" />
                        </a-col>
                      </a-row>

                      <a-row class="mt-10">
                        <a-col :span="8">
                          <h6 class="mt-5 mb-0">Date of Receive</h6>
                        </a-col>
                        <a-col :span="12">
                          <a-date-picker style="width: 100%" v-model="item.date_of_recive" />
                        </a-col>
                      </a-row>
                      <a-row class="mt-10">
                        <a-col :span="8">
                          <h6 class="mt-5 mb-0">Organized by/Granted by</h6>
                        </a-col>
                        <a-col :span="12">
                          <a-input v-model="item.organized_by_granted_by" placeholder="" />
                        </a-col>
                      </a-row>
                      <a-row class="mt-10">
                        <a-col :span="8">
                          <h6 class="mt-5 mb-0">Location</h6>
                        </a-col>
                        <a-col :span="12">
                          <a-textarea placeholder="" :auto-size="{ minRows: 3, maxRows: 5 }"
                            v-model="item.location_and_country" />
                        </a-col>
                      </a-row>

                      <a-row class="mt-10">
                        <a-col :span="8">
                          <h6 class="mt-10 mb-0">Type of award</h6>
                        </a-col>
                        <a-col :span="12">
                          <a-select show-search placeholder="select..." style="width: 100%" option-filter-prop="children"
                            v-model="item.type_award">
                            <a-select-option v-for="(item, index) in [
                              'National',
                              'International',
                              'Organizational',
                            ]" :key="index" :value="item">
                              {{ item }}
                            </a-select-option>
                          </a-select>
                        </a-col>
                      </a-row>

                    </a-col>
                    <a-col :span="2">
                      <a-popconfirm placement="topLeft" ok-text="Yes" cancel-text="No" @confirm="removeAwards(item.id)">
                        <template slot="title">
                          <p class="mt-0 mb-0">Confirm delete ?</p>
                        </template>
                        <a-button type="link" class="text-center">
                          <a-icon style="font-size: 20px; color: red" type="delete" />
                        </a-button>
                      </a-popconfirm>
                    </a-col>
                  </a-row>
                </div>
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </a-form>
      </a-col>
    </a-row>

    <!-- btn action -->
    <a-row class="mt-20">
      <a-col :span="10" :offset="5">
        <a-form-item :wrapper-col="{ span: 14, offset: 4 }">
          <a-button type="primary" class="mr-10" @click="onSubmitAchievements">
            Submit
          </a-button>
          <a-button type="danger" @click="backTomain"> Back </a-button>
        </a-form-item>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  props: {
    dataProfile: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      arrAchiv: [],
      dataAward: [],
      loading: false,
      btnSubmitLoad: false,
      // option form
      optionCompany: [],
      optionCompanyType: [],
      optionSector: [],
      optionPosition: [],
    };
  },
  mounted() {
    this.getAwards();
  },
  methods: {
    backTomain() {
      this.$router
        .push({
          path: "/alumni/",
        })
        .catch((err) => { });
    },
    async getAwards() {
      this.loading = true
      this.dataAward = [];
      try {
        const res = await this.$http.get(
          `/student_affair/alumni-award/?alumni_profile__student_id=${this.dataProfile[0].student_id}`
        );
        if (res.status === 200) {
          // //console.log(res.data)
          this.dataAward = res.data.map((item) => ({ ...item }));
          this.loading = false
        } else {
          throw { res };
        }
      } catch (error) {
        this.loading = false
        this.dataAward = [];
        this.notificationDialog(
          "#ff1919",
          "#ffffff",
          `Error ${error.response.status}`,
          `Problem issue connect api : /student_affair/alumni-award/?alumni_profile__student_id=${this.dataProfile[0].student_id}`
        );
      }
    },
    async addNewAW() {
      var jsonData = {
        alumni_profile: this.dataProfile[0].id,
      };
      try {
        const response = await this.$http.post(
          "/student_affair/alumni-award/",
          jsonData
        );
        if (response.status === 201) {
          this.dataAward.push(response.data);
        } else {
          throw { response };
        }
      } catch (error) { }
    },
    onSubmitAchievements() {
      for (let listForm = 0; listForm < this.dataAward.length; listForm++) {
        var jsonBodyAchievements = {};
        const AwList = this.dataAward[listForm];
        const keys = Object.keys(AwList);
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i];
          // //console.log(key, AwList[key] )
          jsonBodyAchievements[key] =
            key === "date_of_recive"
              ? !["", null, "null"].includes(AwList[key])
                ? this.moment(AwList[key]).format("YYYY-MM-DD")
                : this.moment().format("YYYY-MM-DD")
              : AwList[key];
        }
        this.updateAW(jsonBodyAchievements);
      }
    },
    async updateAW(jsonData) {
      // //console.log(jsonData);
      return new Promise((resolve) => {
        this.$http
          .patch("/student_affair/alumni-award/" + jsonData.id + "/", jsonData)
          .then((response) => {
            if (response.status) {
              this.$emit("successNotification", {
                msg: "Success",
                des: `profile update`,
              });
              resolve(true);
            }
          })
          .catch((error) => {
            resolve(false);
          });
      });
    },
    async removeAwards(idDel) {
      try {
        const res = await this.$http.delete(
          `/student_affair/alumni-award/${idDel}/`
        );
        if (res.status === 204) {
          const indexDel = this.dataAward.findIndex(
            (itemDel) => itemDel.id === idDel
          );
          this.dataAward.splice(indexDel, 1);
        } else {
          throw { res };
        }
      } catch (error) {
        this.$emit("errorNotification", {
          errorMsg: error.response.status,
          urlPath: `/student_affair/alumni-award/${idDel}`,
        });
      }
    },
  },
};
</script>